import { render, staticRenderFns } from "./online-serve.vue?vue&type=template&id=a9958c3c&scoped=true"
import script from "./online-serve.vue?vue&type=script&lang=js"
export * from "./online-serve.vue?vue&type=script&lang=js"
import style0 from "./online-serve.vue?vue&type=style&index=0&id=a9958c3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9958c3c",
  null
  
)

export default component.exports